"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _underscore = require("underscore");
var _types = require("../../actions/knock/types");
function directorRequests() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_RECEIVE_REQUEST)) {
    return state.concat([action.payload]);
  }

  // Removes accepted or rejected request from the director request state
  if (action.type === "".concat(_types.BROADCAST_UPDATE_REQUEST, "_SUCCESS")) {
    return state.filter(function (request) {
      return request._id !== action.payload._id;
    });
  }
  if (action.type === _types.BROADCAST_CLEAR_REQUEST) {
    return state.filter(function (request) {
      return request._id !== action.payload._id;
    });
  }

  // Update the knock request without making a call to the API
  if (action.type === "".concat(_types.BROADCAST_SOURCE_TO_KNOCK)) {
    return state.map(function (knock) {
      return knock._id === action.payload._id ? action.payload : knock;
    });
  }
  if (action.type === "".concat(_types.BROADCAST_APPROVE_ALL_KNOCKS, "_SUCCESS")) {
    return findAndRemoveUpdatedRequests(state, action.payload);
  }
  return state;
}
function findAndRemoveUpdatedRequests(currentRequests, updatedRequests) {
  var updatedRequestIds = (0, _underscore.pluck)(updatedRequests, '_id');
  return currentRequests.filter(function (request) {
    return !updatedRequestIds.includes(request._id);
  });
}
var _default = exports["default"] = directorRequests;